"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxRuleIdentifier = exports.TaxRuleType = exports.TaxRuleCategory = void 0;
var TaxRuleCategory;
(function (TaxRuleCategory) {
    TaxRuleCategory["BusbudFee"] = "busbud_fee";
    TaxRuleCategory["Markup"] = "markup";
    TaxRuleCategory["Commission"] = "commission";
})(TaxRuleCategory = exports.TaxRuleCategory || (exports.TaxRuleCategory = {}));
var TaxRuleType;
(function (TaxRuleType) {
    TaxRuleType["TripOrigin"] = "trip_origin";
    TaxRuleType["ContractAddress"] = "contract_address";
})(TaxRuleType = exports.TaxRuleType || (exports.TaxRuleType = {}));
var TaxRuleIdentifier;
(function (TaxRuleIdentifier) {
    TaxRuleIdentifier["CityID"] = "city_id";
    TaxRuleIdentifier["RegionID"] = "region_id";
    TaxRuleIdentifier["CountryCode"] = "country_code3";
})(TaxRuleIdentifier = exports.TaxRuleIdentifier || (exports.TaxRuleIdentifier = {}));
//# sourceMappingURL=taxes.js.map